import addOrUpdateResource from './src/main'
addOrUpdateResource.install = function (Vue) {
  Vue.component(addOrUpdateResource.name, addOrUpdateResource)
}
export default addOrUpdateResource



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/addOrUpdateResource/index.js